import {
  Component,
  computed,
  inject,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import {
  CustomersStore,
  extractCustomerIdFromUrl,
} from 'src/app/signal-stores/customers.store';

@Component({
  selector: 'ng-bee-customer-static-data',
  templateUrl: './customer-static-data.component.html',
  standalone: false,
  styles: `
    :host {
      width: 100%;
    }
  `,
})
export class CustomerStaticDataComponent implements OnInit {
  private readonly customersStore = inject(CustomersStore);

  @Input() public label: string = 'customer.model.root';
  @Input() public withLabel: boolean = false;

  private readonly detailURL = signal<string>('');

  @Input('detailURL') set _detailURL(value: string) {
    this.detailURL.set(value ?? '');
  }

  readonly customerName = computed(() => {
    const url = this.detailURL();
    if (!url) return '-';
    const id = extractCustomerIdFromUrl(url);
    if (!id) return '-';
    return this.customersStore.customerMap()[id]?.name ?? '-';
  });

  ngOnInit(): void {
    this.customersStore.loadCustomers();
  }
}
